import { ShieldCheck, ShieldAlert, Lock, Landmark, BrainCircuit, Shield } from "lucide-react";

// Central catalog for audit types. When adding a new template on the backend,
// register its visual metadata here.
export const AUDIT_TYPES = {
  gdpr: {
    label: "GDPR",
    long_name: "GDPR - Regolamento UE 2016/679",
    short_ref: "Reg. UE 2016/679 · Garante Privacy",
    icon: ShieldCheck,
    color_bg: "bg-blue-600",
    tile_active_border: "border-blue-600",
    badge_bg: "bg-blue-50",
    badge_text: "text-blue-700",
    tagline: "Regolamento UE 2016/679 · Provvedimenti Garante Privacy",
  },
  nis2: {
    label: "NIS2",
    long_name: "NIS2 - Direttiva UE 2022/2555",
    short_ref: "Dir. UE 2022/2555 · D.Lgs. 138/2024",
    icon: ShieldAlert,
    color_bg: "bg-emerald-600",
    tile_active_border: "border-emerald-600",
    badge_bg: "bg-emerald-50",
    badge_text: "text-emerald-700",
    tagline: "Dir. UE 2022/2555 · D.Lgs. 138/2024 · Gap Analysis",
  },
  iso27001: {
    label: "ISO 27001",
    long_name: "ISO/IEC 27001:2022 - ISMS",
    short_ref: "ISO/IEC 27001:2022",
    icon: Lock,
    color_bg: "bg-slate-800",
    tile_active_border: "border-slate-800",
    badge_bg: "bg-slate-100",
    badge_text: "text-slate-800",
    tagline: "ISO/IEC 27001:2022 · Sistema di Gestione della Sicurezza delle Informazioni",
  },
  dora: {
    label: "DORA",
    long_name: "DORA - Regolamento UE 2022/2554",
    short_ref: "Reg. UE 2022/2554",
    icon: Landmark,
    color_bg: "bg-amber-600",
    tile_active_border: "border-amber-600",
    badge_bg: "bg-amber-50",
    badge_text: "text-amber-700",
    tagline: "Reg. UE 2022/2554 · Digital Operational Resilience Act (finance)",
  },
  ai_act: {
    label: "AI Act",
    long_name: "AI Act - Regolamento UE 2024/1689",
    short_ref: "Reg. UE 2024/1689",
    icon: BrainCircuit,
    color_bg: "bg-fuchsia-700",
    tile_active_border: "border-fuchsia-700",
    badge_bg: "bg-fuchsia-50",
    badge_text: "text-fuchsia-700",
    tagline: "Reg. UE 2024/1689 · AI Act · Sistemi ad alto rischio & GPAI",
  },
};

export const getAuditType = (t) => AUDIT_TYPES[t] || {
  label: (t || "?").toUpperCase(),
  long_name: (t || "?").toUpperCase(),
  short_ref: "",
  icon: Shield,
  color_bg: "bg-slate-600",
  tile_active_border: "border-slate-600",
  badge_bg: "bg-slate-100",
  badge_text: "text-slate-700",
  tagline: "",
};
